module.exports = __webpack_public_path__ + "img/honnor5.3d38291f.png";